/** @format */
/* eslint-disable */ 
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(LocalizedFormat);

export const $_time = {
    /**
     * @public
     * @description
     * Takes a date object and returns a normalised time object for use in our application.
     * 
     * @param {Object} date the date object from which we want to get the time
     * @returns {Object}
     */
	timeFromDate(date) {
		const hours = date.format('HH');
		const minutes = date.format('mm');
		const seconds = date.format('ss');
		return {
			hours,
			minutes,
			seconds,
			mode: parseInt(hours) <= 11 ? 'am' : 'pm',
			dbTimeString: `${hours}:${minutes}:${seconds}`
		};
	},

    /**
     * @public
     * @description
     * Get the current time
     * 
     * @returns {Object}
     */
	getTimeNow() {
		return this.timeFromDate(dayjs());
    },
    
    /**
     * @public
     * @description
     * Updates the targeted selectedDate's `time` object at the required part.
     * Also updates and synchronises properties on this object such as the am, pm
     * mode and also the string of the time itself.
     * 
     * @param {String} part hours, minutes or seconds
     * @param {*} target which time section in the datepicker are we updating?
     * @param {*} value the value to update this to
     * @param {*} instance the currently active datepicker instance
     */
    update(part, target, value, instance) {
		const time = instance.selectedDates[target].time;
		time[part] = value;
		const { hours, minutes, seconds} = time;
		time.dbTimeString = `${hours}:${minutes}:${seconds}`;
		time.mode = parseInt(hours) <= 11 ? 'am' : 'pm';
    },

    /**
     * @public
     * @description
     * Get a date object from the time we pass in (we assign a date that doesnt matter)
     * and then return its parts hours, minutes and seconds
     * 
     * @param {String} inputTime eg 19:30:00
     * 
     * @returns {Object}
     */
    setParts(inputTime) {
        const dateString = `2000-01-01 ${inputTime}`;
        const d = new Date(dateString.replace(' ', 'T'));
        let hours = d.getHours();
        let minutes = d.getMinutes();
        let seconds = d.getSeconds();
        return {
            hours: ('0' + hours).slice(-2),
            minutes: ('0' + minutes).slice(-2),
            seconds: ('0' + seconds).slice(-2),
        }
    }
};

export {$_time as default};
